import { format, formatDistanceToNow, parseISO, isValid, differenceInDays } from "date-fns";
import { de } from "date-fns/locale";

export function parseDate(input: string | Date | null | undefined): Date | null {
  if (!input) return null;
  if (input instanceof Date) return isValid(input) ? input : null;
  const d = parseISO(input);
  return isValid(d) ? d : null;
}

export function formatDate(input: string | Date | null | undefined, pattern = "dd.MM.yyyy"): string {
  const d = parseDate(input);
  if (!d) return "—";
  return format(d, pattern, { locale: de });
}

export function formatDateTime(input: string | Date | null | undefined): string {
  const d = parseDate(input);
  if (!d) return "—";
  return format(d, "dd.MM.yyyy HH:mm", { locale: de });
}

export function formatRelative(input: string | Date | null | undefined): string {
  const d = parseDate(input);
  if (!d) return "—";
  return formatDistanceToNow(d, { addSuffix: true, locale: de });
}

export function daysUntil(input: string | Date | null | undefined): number | null {
  const d = parseDate(input);
  if (!d) return null;
  return differenceInDays(d, new Date());
}

export function dueLabel(input: string | Date | null | undefined): { text: string; tone: "ok" | "soon" | "overdue" | "none" } {
  const n = daysUntil(input);
  if (n === null) return { text: "—", tone: "none" };
  if (n < 0) return { text: `${Math.abs(n)}T überfällig`, tone: "overdue" };
  if (n === 0) return { text: "heute fällig", tone: "soon" };
  if (n <= 3) return { text: `in ${n} Tagen`, tone: "soon" };
  return { text: `in ${n} Tagen`, tone: "ok" };
}
